<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-5 col-form-label"
           for="ustIdentifikationsnummer{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.UMSATZSTEUER_IDENTIFIKATIONSNUMMER' | translate }}</label>
    <div class="col-sm-7">
      <input class="form-control" datevMessagePath="ustIdentifikationsnummer{{objectId}}" formControlName="ustIdentifikationsnummer"
             id="ustIdentifikationsnummer{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>

  <div class="form-check">
    <input class="form-check-input" datevMessagePath="isUmStOrgantraegerIdentischKStUndGewStOrgantraeger{{objectId}}"
           formControlName="isUmStOrgantraegerIdentischKStUndGewStOrgantraeger"
           id="isUmStOrgantraegerIdentischKStUndGewStOrgantraeger{{index}}"
           type="checkbox" utilsCheckValidity
           utilsControlState utilsValidationMessage>
    <label class="form-check-label" for="isUmStOrgantraegerIdentischKStUndGewStOrgantraeger{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.UST_ORGANTRAEGER_MIT_KST_UND_GEWST_IDENTISCH' | translate }}
    </label>
  </div>

  <div class="form-check">
    <input class="form-check-input" datevMessagePath="isUmsatzsteuerOrgangesellschaft{{objectId}}"
           formControlName="isUmsatzsteuerOrgangesellschaft"
           id="isUmsatzsteuerOrgangesellschaft{{index}}"
           type="checkbox" utilsCheckValidity
           utilsControlState utilsValidationMessage>
    <label class="form-check-label" for="isUmsatzsteuerOrgangesellschaft{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.GESELLSCHAFT_IST_UST_ORGANGESELLSCHAFT' | translate }}
    </label>
  </div>

  <div class="form-row mt-5">
    <label class="col-sm-4 col-form-label"
           for="beginnUStOrganschaft{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.BEGINNUSTORGANSCHAFT' | translate }}</label>
    <div class="col-sm-8">
      <date-picker
              id="beginnUStOrganschaft{{index}}"
              messagePath="beginnUStOrganschaft{{objectId}}"
              utilsCheckValidity [isRequired]="data.isUmsatzsteuerOrgangesellschaft"
              formControlName="beginnUStOrganschaft" utilsMarkRequired>
      </date-picker>
    </div>
  </div>

</form>
